import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "@i18n";
import stl from "./PaymentInfo.module.css";
import PriceDetailsShimmer from "@/pages/checkout/components/PaymentInfo/PriceDetailsShimmer";
import { CDN_LINK } from "@globalConfig";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
var PaymentInfo = function PaymentInfo(props) {
  var _checkoutOrder$regist, _checkoutOrder$shippi, _checkoutOrder$warran, _checkoutOrder$roadSe, _checkoutOrder$roadSe2;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var checkoutOrder = props.checkoutOrder,
    hideData = props.hideData,
    isFinance = props.isFinance,
    showRemainingData = props.showRemainingData,
    closeShowAllInfo = props.closeShowAllInfo;
  var _useState = useState(false),
    showGrantedPopup = _useState[0],
    setShowGrantedPopup = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.container, props.className ? props.className : ""].join(" ")
  }, props.loading ? /*#__PURE__*/React.createElement(PriceDetailsShimmer, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, t("تفاصيل السعر", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.ImageName
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.imgContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_image
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.titleContainer
  }, isFinance && /*#__PURE__*/React.createElement("p", {
    className: "m-hide"
  }, t("قيمة الخدمات المضافة على:", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder ? checkoutOrder.post_title : null))), /*#__PURE__*/React.createElement("div", {
    className: stl.genralInfo
  }, !isFinance && !showRemainingData && (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id) && /*#__PURE__*/React.createElement("div", {
    className: stl.flxMeS
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.label
  }, " ", t("رقم الطلب", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    className: stl.orderId
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id)), ((checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_price) || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_price) == 0) && /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, t("قيمة السيارة", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder ? checkoutOrder.post_price : "", /*#__PURE__*/React.createElement("span", {
    className: "text-xl"
  }, t("ريال", {
    ns: "web_checkout_cash"
  }))), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_is_new) == 0 && /*#__PURE__*/React.createElement("p", null, t("السعر يشمل الضريبة المضافة", {
    ns: "web_checkout_cash"
  })), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.limited_quantity) && /*#__PURE__*/React.createElement("p", null, t("يمكن أن يتغير السعر حسب توفر السيارة في السوق", {
    ns: "web_checkout_cash"
  }))), !isFinance ? /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, t("قيمة المضافة على الخدمات", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder ? checkoutOrder.vat : "", /*#__PURE__*/React.createElement("span", {
    className: "text-xl"
  }, t("ريال", {
    ns: "web_checkout_cash"
  }))), /*#__PURE__*/React.createElement("p", null, t("نسبة القيمة المضافة خاضعة للتعديل بموجب القانون", {
    ns: "web_checkout_cash"
  }))) : null, ((checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.registration_fees) || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.registration_fees) == 0) && /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.post_is_new ? /*#__PURE__*/React.createElement("span", null, t("التسجيل واللوحات", {
    ns: "web_checkout_cash"
  })) : /*#__PURE__*/React.createElement("span", null, t("نقل ملكية", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder ? parseInt(checkoutOrder.registration_fees) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, checkoutOrder.registration_fees, " ", /*#__PURE__*/React.createElement("span", {
    className: "text-xl"
  }, t("ريال", {
    ns: "web_checkout_cash"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: stl.freeTag
  }, t("مجانا", {
    ns: "web_checkout_cash"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.oldPrice
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$regist = checkoutOrder.registrationPriceDetails) === null || _checkoutOrder$regist === void 0 ? void 0 : _checkoutOrder$regist.oldPrice, " ", /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_checkout_cash"
  })))) : "")), ((checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.shipping_fees) || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.shipping_fees) == 0) && /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, t("كلفة الشحن", {
    ns: "web_checkout_cash"
  })), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.shipping_fees_show_note) && /*#__PURE__*/React.createElement("div", {
    className: "flex gap-[9px] w-[150px] items-center justify-end"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-[#6D7A8D] text-sm font-bold leading-6"
  }, t("ستحدد لاحقاً", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("img", {
    className: "hasEvents cursor-pointer",
    onClick: function onClick() {
      closeShowAllInfo && closeShowAllInfo();
      setShowGrantedPopup(true);
    },
    src: CDN_LINK + "/assets/images/Vector.svg",
    alt: "icon"
  })), !(checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.shipping_fees_show_note) && /*#__PURE__*/React.createElement("strong", null, checkoutOrder ? parseInt(checkoutOrder.shipping_fees) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, checkoutOrder.shipping_fees, " ", /*#__PURE__*/React.createElement("span", {
    className: "text-xl"
  }, t("ريال", {
    ns: "web_checkout_cash"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: stl.freeTag
  }, t("مجانا", {
    ns: "web_checkout_cash"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.oldPrice
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$shippi = checkoutOrder.shippingPriceDetails) === null || _checkoutOrder$shippi === void 0 ? void 0 : _checkoutOrder$shippi.oldPrice, " ", /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_checkout_cash"
  })))) : null)), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.warranty) && Object.keys(checkoutOrder.warranty).length > 0 && /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, checkoutOrder.warranty.name, " ", /*#__PURE__*/React.createElement("p", {
    className: stl.smlNotesss
  }, " ", checkoutOrder && checkoutOrder.warranty.text, " ")), /*#__PURE__*/React.createElement("strong", {
    className: stl.freeTag
  }, checkoutOrder && checkoutOrder.warranty.price != "0" && checkoutOrder.warranty.old_price && /*#__PURE__*/React.createElement("span", {
    className: stl.oldPrice
  }, checkoutOrder.warranty.old_price, t("ريال", {
    ns: "web_checkout_cash"
  }), " "), checkoutOrder && checkoutOrder.warranty.price == "0" ? /*#__PURE__*/React.createElement("div", {
    className: stl.freeTag
  }, t("مجانا", {
    ns: "web_checkout_cash"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.oldPrice
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$warran = checkoutOrder.warrantyPriceDetails) === null || _checkoutOrder$warran === void 0 ? void 0 : _checkoutOrder$warran.oldPrice, " ", /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_checkout_cash"
  })))) : checkoutOrder.warranty.price)), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.roadService) && Object.keys(checkoutOrder.roadService).length > 0 && /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, checkoutOrder.roadService.name, /*#__PURE__*/React.createElement("p", {
    className: stl.smlNotesss
  }, " ", checkoutOrder.roadService.text, " ")), /*#__PURE__*/React.createElement("strong", {
    className: stl.freeTag
  }, checkoutOrder.roadService.old_price && /*#__PURE__*/React.createElement("span", {
    className: stl.oldPrice
  }, checkoutOrder.roadService.old_price, t("ريال", {
    ns: "web_checkout_cash"
  }), " "), checkoutOrder.roadService.price == "0" ? /*#__PURE__*/React.createElement("div", {
    className: stl.freeTag
  }, t("مجانا", {
    ns: "web_checkout_cash"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.oldPrice
  }, checkoutOrder && (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.roadServicePriceDetail) && (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$roadSe = checkoutOrder.roadServicePriceDetail) === null || _checkoutOrder$roadSe === void 0 ? void 0 : _checkoutOrder$roadSe.oldPrice) && (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$roadSe2 = checkoutOrder.roadServicePriceDetail) === null || _checkoutOrder$roadSe2 === void 0 ? void 0 : _checkoutOrder$roadSe2.oldPrice), " ", /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_checkout_cash"
  })))) : checkoutOrder.roadService.price)), checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.referral_discount && checkoutOrder.referral_discount != 0 ? /*#__PURE__*/React.createElement("div", {
    className: [stl.flx, stl.ArboonRow, stl.discount].join(" ")
  }, /*#__PURE__*/React.createElement("span", null, t("خصم إضافي كود", {
    ns: "web_checkout_cash"
  }), " ", "(", checkoutOrder.referral_code, ")"), /*#__PURE__*/React.createElement("strong", null, checkoutOrder.referral_discount, /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_checkout_cash"
  })))) : null, checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.service_amount || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.service_amount) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, t("قيمة الخدمات المضافة", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder ? checkoutOrder.service_amount : "", /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_checkout_cash"
  })))) : "", checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.vas_amount || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.vas_amount) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, t("قيمة الضريبة المضافة", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder ? checkoutOrder.vas_amount : "", /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_checkout_cash"
  }))), /*#__PURE__*/React.createElement("p", null, t("نسبة القيمة المضافة خاضعة للتعديل بموجب القانون", {
    ns: "web_checkout_cash"
  }))) : "", !showRemainingData && /*#__PURE__*/React.createElement("div", {
    className: [stl.flx, stl.totalRow, isFinance ? stl.borderBottom : ""].join(" ")
  }, /*#__PURE__*/React.createElement("span", null, t("المبلغ الإجمالي", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, isFinance ? checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.total_amount : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.total_price, /*#__PURE__*/React.createElement("span", {
    className: "!text-2xl"
  }, t("ريال", {
    ns: "web_checkout_cash"
  })))), !hideData && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.flx, stl.ArboonRow].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.colFlex
  }, /*#__PURE__*/React.createElement("span", null, t("عربون من قيمة السيارة", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", null, t("هذا العربون مسترد بالكامل حتى مرحلة تسجيل السيارة، وسيتم خصم العربون من المبلغ الإجمالي.", {
    ns: "web_checkout_cash"
  }))), /*#__PURE__*/React.createElement("strong", null, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.arboun, /*#__PURE__*/React.createElement("span", {
    className: "!text-2xl"
  }, t("ريال", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: stl.note
  }, t("مستردة", {
    ns: "web_checkout_cash"
  }))))), showRemainingData && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.flx, " ").concat(stl.borderTop)
  }, /*#__PURE__*/React.createElement("span", null, t("عربون من قيمة السيارة", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.arboun, " -", /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_common"
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, t("المبلغ المدفوع", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.payed_amount, " -", /*#__PURE__*/React.createElement("span", {
    className: "text-2xl"
  }, t("ريال", {
    ns: "web_checkout_cash"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.flx, " ").concat(stl.boldFlex)
  }, /*#__PURE__*/React.createElement("span", null, t("المبلغ المتبقي", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, isFinance ? checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.remaining_amount : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.remaining_price_payed, /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_common"
  })))))))), /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: showGrantedPopup,
    onClose: function onClose() {
      return setShowGrantedPopup(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-8 p-[13px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/infoOrange.svg",
    width: "96px",
    height: "82px",
    alt: "icon"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-[#3C56D4] text-center text-[32px] font-bold leading-[32px]"
  }, t("تكلفة الشحن", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-[#3C56D4] text-center font-[Cairo] text-[20px] font-semibold leading-[32px]"
  }, t("سيتم تحديد تكلفة الشحن من خلال مندوب المبيعات بعد تأكيد الحجز", {
    ns: "web_checkout_cash"
  })))));
};
export default PaymentInfo;